export type YardSelectionTypes = "FRONT YARD" | "BACK YARD" | "ENTIRE PROPERTY";

export const FRONT_YARD: YardSelectionTypes = "FRONT YARD";

export const BACK_YARD: YardSelectionTypes = "BACK YARD";

export const ENTIRE_PROPERTY: YardSelectionTypes = "ENTIRE PROPERTY";
